// client/src/components/BidEstimation/Documents/DocumentFilterBar.js
// Category filter chips + filename search for the Documents panel.
// Pure presentational — parent owns activeCategory / searchTerm state.
import React from 'react'
import { CATEGORY_CHIP } from './documentDisplay'

// Human label for a category key — falls back to the key itself.
const categoryLabel = (key) => (CATEGORY_CHIP[key] && CATEGORY_CHIP[key].label) || key

const chipStyle = (active) => ({
  display: 'inline-flex', alignItems: 'center', gap: 5,
  padding: '3px 10px', borderRadius: 14, cursor: 'pointer',
  fontSize: 11.5, fontWeight: 600, whiteSpace: 'nowrap',
  transition: 'background 0.1s',
  background: active ? 'var(--ink, #1e1e1e)' : 'var(--bg-panel-alt, #f0f0f0)',
  color: active ? '#fff' : 'var(--ink-2, #444)'
})

/**
 * @param {Array}  items           unified list items, each with a `category`
 * @param {string} activeCategory  'all' or a category key
 * @param {string} searchTerm
 * @param {func}   onCategoryChange (categoryKey) => void
 * @param {func}   onSearchChange   (term) => void
 */
export default function DocumentFilterBar ({
  items = [], activeCategory = 'all', searchTerm = '',
  onCategoryChange, onSearchChange
}) {
  // Counts per category present in the unified list
  const counts = {}
  for (const it of items) {
    const c = it.category || 'other'
    counts[c] = (counts[c] || 0) + 1
  }
  // Categories that actually have items, stable-sorted by label
  const presentCategories = Object.keys(counts).sort(
    (a, b) => categoryLabel(a).localeCompare(categoryLabel(b))
  )

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      flexWrap: 'wrap', marginBottom: 8
    }}>
      <span
        style={chipStyle(activeCategory === 'all')}
        onClick={() => onCategoryChange('all')}
      >
        All ({items.length})
      </span>
      {presentCategories.map(cat => (
        <span
          key={cat}
          style={chipStyle(activeCategory === cat)}
          onClick={() => onCategoryChange(cat)}
        >
          {categoryLabel(cat)} ({counts[cat]})
        </span>
      ))}
      <input
        type="text"
        value={searchTerm}
        onChange={e => onSearchChange(e.target.value)}
        placeholder="Search documents…"
        style={{
          marginLeft: 'auto', height: 28, width: 180, boxSizing: 'border-box',
          padding: '0 10px', borderRadius: 14,
          border: '1px solid var(--line-2, #d0d0d0)', background: 'var(--bg-panel, #fff)',
          fontSize: 12, color: 'var(--ink, #1e1e1e)', outline: 'none'
        }}
      />
    </div>
  )
}
